// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.renter.v1.conversation.SatelliteWebRenterConversationHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  SatelliteWebRenterConversationAddMessageRequestDto,
  SatelliteWebRenterConversationAddMessageResponseDto,
  SatelliteWebRenterConversationGetLatestConversationsRequestDto,
  SatelliteWebRenterConversationGetLatestConversationsResponseDto,
  SatelliteWebRenterConversationGetMessagesByInquiryIdRequestDto,
  SatelliteWebRenterConversationGetMessagesByInquiryIdResponseDto,
  SatelliteWebRenterConversationGetMessagesRequestDto,
  SatelliteWebRenterConversationGetMessagesResponseDto,
  SatelliteWebRenterConversationUpdateStatusRequestDto,
} from '../..';

export const SatelliteWebRenterConversationHandler_addMessage_Path = '/api/web/renter/v1/conversation/addMessage';

/**
 * Add a message to a conversation
 */
export const SatelliteWebRenterConversationHandler_addMessage = (
  postData: SatelliteWebRenterConversationAddMessageRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebRenterConversationAddMessageRequestDto,
    SatelliteWebRenterConversationAddMessageResponseDto
  >(
    {
      endpoint: SatelliteWebRenterConversationHandler_addMessage_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebRenterConversationHandler_getLatestConversations_Path =
  '/api/web/renter/v1/conversation/getLatestConversations';

/**
 * Get a renter's most recently updated conversations. Each conversation will include one message for that conversation. If the entire conversation consists of nothing but system messages, then the message included will be the most recent system message, otherwise the message included will be the most recent user message even if the most recent message is actually a system message. That is, system messages will only be returned if the entire conversation is composed solely of system messages.
 */
export const SatelliteWebRenterConversationHandler_getLatestConversations = (
  postData: SatelliteWebRenterConversationGetLatestConversationsRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebRenterConversationGetLatestConversationsRequestDto,
    SatelliteWebRenterConversationGetLatestConversationsResponseDto
  >(
    {
      endpoint: SatelliteWebRenterConversationHandler_getLatestConversations_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebRenterConversationHandler_getMessages_Path = '/api/web/renter/v1/conversation/getMessages';

/**
 * Get messages for a conversation
 */
export const SatelliteWebRenterConversationHandler_getMessages = (
  postData: SatelliteWebRenterConversationGetMessagesRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebRenterConversationGetMessagesRequestDto,
    SatelliteWebRenterConversationGetMessagesResponseDto
  >(
    {
      endpoint: SatelliteWebRenterConversationHandler_getMessages_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebRenterConversationHandler_getMessagesByInquiryId_Path =
  '/api/web/renter/v1/conversation/getMessagesByInquiryId';

/**
 * Get the most recent 10 messages for a conversation by inquiry Id
 */
export const SatelliteWebRenterConversationHandler_getMessagesByInquiryId = (
  postData: SatelliteWebRenterConversationGetMessagesByInquiryIdRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    never,
    SatelliteWebRenterConversationGetMessagesByInquiryIdRequestDto,
    SatelliteWebRenterConversationGetMessagesByInquiryIdResponseDto
  >(
    {
      endpoint: SatelliteWebRenterConversationHandler_getMessagesByInquiryId_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};

export const SatelliteWebRenterConversationHandler_updateStatus_Path = '/api/web/renter/v1/conversation/updateStatus';

/**
 * Update conversation status
 */
export const SatelliteWebRenterConversationHandler_updateStatus = (
  postData: SatelliteWebRenterConversationUpdateStatusRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, SatelliteWebRenterConversationUpdateStatusRequestDto, void>(
    {
      endpoint: SatelliteWebRenterConversationHandler_updateStatus_Path,
      method: 'POST',
      contextPath: '/satellite',
      postData: postData,
    },
    client,
  );
};
